import Typography from "components/elements/Typography";
import classes from "./classes.module.scss";

type IProps = {
	tag: string;
};

export default function ProjectTag(props: IProps) {
	return (
		<div className={classes["root"]}>
			<Typography type="p" weight="medium" size="small" color="white" className={classes["tag-text"]}>
				{props.tag}
			</Typography>
		</div>
	);
}
